<button
  mat-flat-button
  color="secondary"
  class="mat-slim-button"
  *hasPermission="[EPermissions.creatorInvitationCreate]"
  (click)="onInviteClick()"
>
  <div class="flex items-center gap-1">
    @if (creatorInvitation()) {
      @if (creatorInvitation()?.createdUserId) {
        <span
          class="rounded-full bg-shikenso-success-base w-2 h-2"
          [matTooltip]="'pages.creatorDetails.creatorInvitation.accepted' | translate"
        ></span>
      } @else if (invitationExpired()) {
        <span
          class="rounded-full bg-shikenso-error-base w-2 h-2"
          [matTooltip]="'pages.creatorDetails.creatorInvitation.expired' | translate"
        ></span>
      } @else {
        <span
          class="rounded-full bg-shikenso-warning-base w-2 h-2"
          [matTooltip]="'pages.creatorDetails.creatorInvitation.notYetAccepted' | translate"
        ></span>
      }

      <span>{{ 'pages.creatorDetails.creatorInvitation.invited' | translate }}</span>
    } @else {
      <span>{{ 'pages.creatorDetails.creatorInvitation.invite' | translate }}</span>
    }
  </div>
</button>
